{
  "_ARTVIKT": "Vikt",
  "SEE_ALL_DOWNLOADS": "Se alla nedladdningar",
  "PRODUCT_SPECIFICATION": "Produktspecifikation",
  "OH_TA_MAILNOTIFIED": "E-Mail, leveransinformation",
  "OH_EDITEXT": "Meddelande",
  "TYLO_FREIGHT_COST": "Fraktkostnad på <strong>{{value}} {{currencyCode}}</strong> läggs till",
  "TYLO_FREIGHT_COST_ERROR": "Fraktkostnad kan ej beräknas",
  "TYLO_MIN_ORDER_ADMIN_FEE": "Administrationsavgift {{fee}} kommer att tillämpas då ordervärdet understiger {{min}})",
  "TYLO_ADMIN_FEE": "Administrationsavgift",
  "ADMIN_CHARGE": "Administrationsavgift",
  "PART_DELIVERY": "Leveransval",
  "TYLO_PART_DELIVERY_MESSAGE": "Produkterna kommer dellevereras, frakt tillkommer på varje enskild leverans.",
  "TYLO_OH_LEVSATTKOD_1": "DSV",
  "TYLO_OH_LEVSATTKOD_5": "DSV, avisering",
  "TYLO_OH_LEVSATTKOD_66": "DHL, Service Point",
  "TYLO_OH_LEVSATTKOD_67": "DHL, Företag",
  "TYLO_OH_DELLEVTILLATEN_0": "Ja",
  "TYLO_OH_DELLEVTILLATEN_10": "Nej",
  "MESSAGE": "Meddelande",
  "OH_Q_OH_TELEAVISERING": "Telefon",
  "TYLO_TRACK_ORDER": "Spåra",
  "BENCH_SLAT": "Bänksits",
  "BENCH_WIDTH": "Bänkbredd (mm)",
  "COLOR": "Färg",
  "CONTROL_PANEL": "Manöverpanel",
  "DEPTH": "Djup (mm)",
  "DESCRIPTION_TECHNICAL": "Teknisk beskrivning",
  "DIMENSION": "Dimension (mm)",
  "DIMENSION_HWL_MM": "HxBxL (mm)",
  "DIMENSION_LHD": "LxHxD (mm)",
  "FRAME_DIMENSON_WHD": "Karm BxHxD (mm)",
  "GLASS": "Glas",
  "HANDLE": "Handtag",
  "HEIGHT": "Höjd (mm)",
  "HINGE_SIDE": "Gånggärn (sida)",
  "HS_CODE": "Tullkod",
  "HSCODE": "Tullkod",
  "INSTALLATION": "Installation",
  "IP_CLASS": "IP Klass",
  "ITEM_NAME": "Produktnamn",
  "ITEM_STATUS_CODE": "Jeeves status-kod",
  "kW": "kW",
  "LED_OUTLETS": "LED uttag",
  "LENGTH": "Längd",
  "LENGTH_MM": "Längd (mm)",
  "LONG_DESCRIPTION": "Lång beskrivning",
  "MAINCATAGORY": "Huvudkategori",
  "MATERIAL": "Material",
  "MAX_LOAD": "Maxbelastning (W)",
  "MAX_LOAD_W": "Maxbelastning (W)",
  "OUTLETSHOP": "Outlet",
  "POWER": "Effekt (kW)",
  "KW": "Effekt (kW)",
  "EFFECT_W": "Effekt (W)",
  "PRODUCT_DISCOUNT_CLASS": "Produktrabattklass",
  "PRODUCT_GROUP": "Varugrupp",
  "PROFILE": "Profil",
  "RELAY_BOX": "Reläbox",
  "ROOM_SIZE": "Rumsstorlek (m3)",
  "SAFETYDISTANCE_CEILING": "Minsta takhöjd (mm)",
  "SAFETYDISTANCE_WALL": "Minsta avstånd till sidovägg (mm)",
  "SAFETYDISTANCECEILING": "Minsta takhöjd (mm)",
  "SAFETYDISTANCEWALL": "Minsta avstånd till sidovägg (mm)",
  "SALES_CHANNEL": "Säljkanal",
  "SALESCHANNEL_FI": "Tylö FI",
  "SALESCHANNEL_JP": "Tylö JP",
  "SALESCHANNEL_SE": "Tylö SE",
  "SALESCHANNEL_UK": "Tylö UK",
  "SALESCHANNEL_US": "Tylö US",
  "SLAT": "Sits",
  "STEAM_PRODUCTION": "Ångproduktion",
  "STONE": "Sten",
  "STONE_LBS": "Sten (lbs)",
  "SUBCATAGORY": "Underkategori",
  "SUPPLIER_ID": "Leverantörsnummer",
  "SUPPLIER_ITEM_ID": "Leverantörens artikelnummer",
  "SUPPLIER_ITEM_NAME": "Leverantörens artikelbeskrivning",
  "TARIC_CODE": "Tullkod",
  "THRESHOLD": "Tröskel",
  "TRANSPORT_INFO": "Transportinformation",
  "VOLTAGE": "Spänning (Volt)",
  "WIDTH": "Bredd (mm)",
  "WOOD": "Trä",
  "CONTROLPANEL": "Manöverpanel",
  "RELAYBOX": "Reläbox",
  "ADD_TO_CART": "Order",
  "CATEGORY_LEVEL_3": "Underkategori",
  "DELIVERY_PLANNING": "Leveransplanering",
  "TYLO_EDIT_DELIVERY_ADDRESS": "Klicka i rutan för att byta och ändra leveransadress för din order",
  "TYLO_DELIVERY_TIME_PRELIMINARY": "Leveransdatum är preliminär, ordern behöver leveransplaneras av vår produktionsplanering. Datum för leverans kommer att meddelas i separat utskick inom kort",
  "CLAIM_FORM": "Garantiformulär",
  "EDIT_NOTE": "Redigera anteckningen",
  "HIDE_PRICE": "Dölj priser",
  "REQUEST_DELIVERY_DATE": "Begärt leveransdatum",
  "RESTORE_AVAILABLE_DATES": "Återställ tillgängliga datum",
  "Q_MS_AR_COLOR": "Färg",
  "Q_MS_AR_KW": "Wattförbrukning",
  "Q_MS_AR_RSIZE": "Antal stenar",
  "Q_MS_AR_SSIZE": "Bastustorlek",
  "ARTVIKT": "Nettovikt",
  "artbtotviukt": "Bruttovikt",
  "Q_MS_ARTLENGTH": "Bredd produkt",
  "Q_MS_ARTHEIGHT": "Höjd produkt",
  "Q_MS_ARTWIDTH": "Djup produkt",
  "Q_AR_LANGD": "Längd produkt",
  "Q_AR_HOJD": "Höjd paket",
  "Q_AR_BREDD": "Bredd paket",
  "Q_MS_AR_SD1": "Säkerhetsavstånd framåt",
  "Q_MS_AR_SD2": "Säkerhetsavstånd bakåt",
  "Q_MS_AR_SD3": "Säkerhetsavstånd uppåt",
  "Q_MS_AR_SD4": "Säkerhetsavstånd åt sidan",
  "Q_MS_AR_SD5": "Säkerhetsavstånd till vattentank",
  "Q_MS_AR_SD6": "Säkerhetsavstånd nedåt",
  "Q_MS_AR_VOLT1": "Spänning 1",
  "Q_MS_AR_VOLT2": "Spänning 2",
  "Q_MS_AR_VOLT3": "Spänning 3",
  "Q_MS_AR_VOLT4": "Spänning 4",
  "ARTSTATNR": "Tullkod",
  "Q_AR_SSTL": "Elnummer",
  "ARTNREAN": "EAN",
  "URSPRUNGSLAND": "Ursprungsland",
  "SHOW_ADVANCED": "Visa avancerat",
  "HIDE_ADVANCED": "Dölj avancerat",
  "VISIBLE_FOR_ASSORTMENTS": "Synlig för sortiment",
  "VISIBLE_FOR_CUSTOMERS": "Synlig för kunder",
  "HIDE_FOR_CUSTOMERS": "Dölj för kunder",
  "3D_CONFIGURATOR": "3D configurator",
  "AMOUNT_OF_CREDIT_LEFT": "Amount of credit left {{creditLeft}}",
  "VISIBLE_ON_DOCUMENT_PAGE": "Synlig på dokumentsidan",
  "COUNTRYOFORIGIN": "Ursprungsland",
  "SUPPLIERITEMID": "Leverantörens artikelnummer",
  "SUPPLIERITEMNAME": "Leverantörens artikelnamn",
  "PRODUCTGROUP": "Produktgrupp",
  "PRODUCTDISCOUNTCLASS": "Produktrabatt-klass",
  "LEDOUTLETS": "LED-uttag",
  "BENCHWIDTH": "Bänkbredd",
  "FRAMEDIMENSIONWHD": "Dimensioner ram (b,h,d)",
  "IPCCLASS": "IP-class",
  "STEAMPRODUCTION": "Ångproduktion",
  "MAXLOAD": "Maxbelastning",
  "MAXLOAD_W": "Maxbelastning (W)",
  "ENUMBER": "E-nummer",
  "TYLO_DELIVERY": "Närmaste leveransdag",
  "BENCHSLAT_MM": "Ribbredd",
  "SPLIT_DELIVERIES": "Delad leverans",
  "NET": "Netto",
  "GROSS": "Brutto",
  "TYLO_CART_NOTE": "Notera att de flesta artiklar produceras mot order och därför är det viktigt att artiklarna får det planerade leveransdatumet för att undvika lagerhyra. Möjlighet finns att dela upp leveransen och vid delleverans debiteras frakt vid varje enskilt leveranstillfälle. Standardorders kan inte bli framflyttade eller annullerade senare än 5 arbetsdagar före bekräftat leveransdatum. Välj under flik ”Leveransval” hur du önskar få din leverans.",
  "SELECT_DELIVERY": "Välj leveransalternativ",
  "DELIVERY_CHOICE_REQUIRED": "Leveransval krävs",
  "OH_DELLEVTILLATEN_0": "Delleverans",
  "OH_DELLEVTILLATEN_10": "Samleverans",
  "ORDER_EDIT_TERMS": "Leveransdatum kan justeras fram till 24 timmar efter lagd order",
  "APPLY_ON_WHOLE_ORDER": "Bocka i ruta om du vill ändra alla raders leveransdatum",
  "CLAIM_INFORMATION": "Vänligen fyll i din felbeskrivning så noggrant som möjligt så att vi kan behandla ditt ärende snabbt.",
  "PRODUCT_EXPORT_XLSX_IMAGES_DOCUMENTS": "XLSX bilder och dokument",
  "CUSTOMER_ORDER_ID": "Kundbestnr",
  "CONCEPT_SHOW_DETAILS": "Fler varianter",
  "MORE_EXPECTED_DATE": "Mer förväntas under {{date}}",
  "SPARE_PARTS": "Varaosat",
  "TYLO_ARRANGES_FREIGH": "Tylö arrangerar frakten*",
  "TYLO_ARRANGES_FREIGH_TERM": "*Minsta ordervärde 500€. Om ordervärdet understiger gränsen så kommer en administrationsavgift på 30€ tillkomma.",
  "TYLO_ARRANGES_FREIGH_NOTE": "För att undvika flera fraktkostnader, se till att alla rader har samma leveransdatum. När sändningen är bokad kommer priset att finnas tillgängligt under Tidigare beställningar.",
  "TYLO_CART_NOTE_29_37": "The delivery date is preliminary and will manually be changed to first available delivery date (based on the lead time for each article) once your account balance is met.\n\nStandard orders cannot be postponed or cancelled later than 5 working days prior confirmed dispatch date.",
  "TYLO_FREIGHT_COST_MANUAL": "Fraktpriset har ej gått att beräkna och kommer beräknas manuellt. Ordererkännande innehållande fraktpris kommer skickas separat.",
  "TYLO_TEMP_FREIGHT": "Temporär frakt",
  "TYLO_TEMP_FREIGHT_DESCRIPTION": "Notera att givet det nuvarande läget runt röda havet kan en temporär extra fraktkostnad tilläggas vid leverans av specifika produkter.",
  "AVAILABLE_NUMBER_EXCEEDED_ALERT": "Den här produkten kan inte beställas i en större mängd. Vänligen kontakta vår support på <a href='mailto:tps@sauna360.com'>tps@sauna360.com</a> så hjälper de dig.",
  "PARTIAL_DELIVERY_POPUP_TEXT": "Vid delleverans debiteras frakt vid varje leveranstillfälle",
  "ESTIMATED_PRODUCTION_TIME": "Uppskattad produktionstid är {{leadtime}} dagar"
}
